import React from "react"
import SignUpFindAccountSuccessPage from "components/signup-find-account-success"
import { SignUpFindAccountSuccessProvider } from "components/signup-find-account-success/context/SignUpFindAccountSuccessContext"

export default function SignUpFindAccountSuccess() {
  return (
    <SignUpFindAccountSuccessProvider>
      <SignUpFindAccountSuccessPage />
    </SignUpFindAccountSuccessProvider>
  )
}
